export default "__VITE_ASSET__C$C94X9a__"